import { render, staticRenderFns } from "./PmwSelectedItemsList.vue?vue&type=template&id=c05ad9da&scoped=true&"
import script from "./PmwSelectedItemsList.vue?vue&type=script&lang=js&"
export * from "./PmwSelectedItemsList.vue?vue&type=script&lang=js&"
import style0 from "./PmwSelectedItemsList.vue?vue&type=style&index=0&id=c05ad9da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05ad9da",
  null
  
)

export default component.exports